import { useAuthStore } from '@/stores/authStore'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getOrganizationUsageInfo } from '@/api/organization'

type Usage = {
  questions: number;
  mb_docs: number;
  mb_spreadsheets: number;
  mb_translator: number;
  minutes: number;
  users: number;
  mbs_uploaded: number;
}

export interface UsageInfo {
  plan: Plan | undefined;
  usage: Usage | null;
  isLoading: boolean;
  error: Error | null;
  refreshPlan: () => Promise<void>;
}

export function usePlan(): UsageInfo {
  const { accessToken } = useAuthStore(state => state.auth)
  const queryClient = useQueryClient()

  const { 
    data: usageInfo, 
    isLoading, 
    error,
    refetch
  } = useQuery({
    queryKey: ['usageInfo'],
    queryFn: getOrganizationUsageInfo,
    enabled: !!accessToken,
    staleTime: 30 * 60,
    refetchOnWindowFocus: true,
  })

  const refreshPlan = async () => {
    queryClient.invalidateQueries({ queryKey: ['usageInfo'] })
    await refetch()
  }

  return { 
    plan: usageInfo?.plan,
    usage: usageInfo ? {
      questions: usageInfo.current_questions,
      mb_docs: usageInfo.current_mb_docs,
      mb_spreadsheets: usageInfo.current_mb_spreadsheets,
      mb_translator: usageInfo.current_mb_translator,
      minutes: usageInfo.current_minutes,
      users: usageInfo.current_users,
      mbs_uploaded: usageInfo.current_mbs_uploaded,
    } : null,
    isLoading,
    error,
    refreshPlan
  }
} 





